/**
 * Component Name: ScrollToTop
 *
 * Description:
 * The ScrollToTop component ensures the user is taken to the top of the page
 * whenever the route changes. This is useful for single-page applications
 * where content dynamically changes based on the route.
 *
 * Usage:
 * Place this component at the root level of your app, typically inside
 * the Router or a layout component, to ensure all routes are affected.
 *
 * Example:
 *  const App: React.FC = () => {
 *   return (
 *     <Router>
 *       <ScrollToTop />
 *
 * Props:
 * None.
 *
 * Notes:
 * - This component does not render any visible elements; it simply attaches
 *   behavior to the page's routing.
 * - Ensure this component is used in conjunction with `react-router-dom` for
 *   proper functionality.
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTopFunc: React.FC = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};

export default ScrollToTopFunc;
